import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["data-test-id"]

import { usePageStore } from '@/store';
import { ComponentRendering, Placeholder } from '@sitecore-jss/sitecore-jss-vue';
import { onMounted, onUnmounted, ref } from 'vue';
import { useRoute } from 'vue-router';


export default /*@__PURE__*/_defineComponent({
  __name: 'EmbeddedPageLayout',
  props: {
    rendering: {}
  },
  setup(__props: any) {

const props = __props;
const parentAdobeDataLayout = ref<any[]>([]);

// ---------------------------------------------------------
// Setup observer to adjust iframe height
// ---------------------------------------------------------
const route = useRoute();
const bodyEl = document.querySelector('body');
const dataTestId = usePageStore().dataTestId(props.rendering);
const resizeObserver = new ResizeObserver(() => {
  requestAnimationFrame(() => {
    const iframe = window.parent.document.querySelector(
      (route.query.iframeSelector as string) ?? 'iframe'
    ) as HTMLIFrameElement;
    const bodyHeight = bodyEl?.scrollHeight + 'px';
    if (iframe && bodyHeight != iframe.style.height) iframe.style.setProperty('height', bodyHeight);
    updateAdobeDataLayer();
  });
});

onMounted(() => {
  updateAdobeDataLayer();
  resizeObserver.observe(bodyEl!);
});

onUnmounted(() => {
  resizeObserver.unobserve(bodyEl!);
});

const updateAdobeDataLayer = () => {
  if (window !== window.parent) {
    setTimeout(() => {
      window.parent.adobeDataLayer = [...parentAdobeDataLayout.value, ...(window.adobeDataLayer ?? [])];
    }, 1000);
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    id: "embedded-page-container",
    "data-test-id": _unref(dataTestId)
  }, [
    _createVNode(_unref(Placeholder), {
      name: "jss-ss-main",
      rendering: _ctx.rendering
    }, null, 8, ["rendering"])
  ], 8, _hoisted_1))
}
}

})